import React from 'react'
import { Desc } from '../../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../../Components/consts'
  import {
  ASGTeamIds,
  returnASGCoach,
  returnWLLASGCoach,
  WLLASGTeamIds,
} from '../../../../../../Constant'

type CoachParams = {
  team: ASGTeamIds | WLLASGTeamIds
}

export const Coach: React.FC<React.PropsWithChildren<CoachParams>> = ({ team }) => {
  return (
    <>
      {team === 'east' && (
        <>
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('away', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>
            {returnASGCoach('away', 'assistant')}
          </Desc>
        </>
      )}
      {team === 'west' && (
        <>
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('home', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>
            {returnASGCoach('home', 'assistant')}
          </Desc>
        </>
      )}
      {team === 'team izzy' && (
        <>
          <Desc textColor={colors.gray.gray40}>{returnWLLASGCoach('away', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>
            {returnWLLASGCoach('away', 'assistant')}
          </Desc>
        </>
      )}
      {team === 'team north' && (
        <>
          <Desc textColor={colors.gray.gray40}>{returnWLLASGCoach('home', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>
            {returnWLLASGCoach('home', 'assistant')}
          </Desc>
        </>
      )}
    </>
  )
}
